interface Step {
  action?: string | null;
  elementType?: string | null;
  domText?: string | null;
  value?: string | null;
  initialValue?: string | null;
}

export const getStepAction = (step: Step | undefined | null) => {
  if (!step) {
    return "";
  }
  let stepAction = "";
  if (step.action) {
    stepAction += `${step.action} `;
  }

  if (step.elementType) {
    stepAction += `${step.elementType} `;
  }

  if (step.domText) {
    stepAction += `"${step.domText}" `;
  }


  if (step.action === "Input") {
    if (step.value) {
      stepAction += `"New Value: ${step.value}" `;
    }
    if (step.initialValue) {
      stepAction += `"Initial Value: ${step.initialValue}" `;
    }
  }
  return stepAction;
}